import React, { useEffect } from 'react'
import { Redirect, useParams } from 'react-router-dom'
import clsx from 'clsx'
import Box from '@material-ui/core/Box'
import LinearProgress from '@material-ui/core/LinearProgress'
import Typography from '@material-ui/core/Typography'
import { PageHeader } from 'components/page-header'
import { useMyVirtualCoachingRequest } from './api-hooks'
import {
  trackVirtualCoachingStudentEvent,
  VIRTUAL_COACHING_STUDENT_EVENTS,
} from './analytics'
import { RequestLoadError, RequestNotFound } from './request-state-messages'
import { useStyles } from './styles'
import UploadForm from './upload-form'
import { getRequestPath, REQUEST_STATUS, REQUESTS_PATH } from './utils'

const CRUMBS = [{ label: 'Virtual Coaching', to: REQUESTS_PATH }]

const UploadPage = () => {
  const classes = useStyles()
  const { requestId } = useParams()
  const { data, loading, error, refetch } = useMyVirtualCoachingRequest(
    requestId,
  )
  const request = data?.myVirtualCoachingRequest
  const canUpload = request?.status === REQUEST_STATUS.PURCHASED

  useEffect(() => {
    if (!request?.id || !canUpload) return
    trackVirtualCoachingStudentEvent(
      VIRTUAL_COACHING_STUDENT_EVENTS.UPLOAD_VIEWED,
      { requestId: request.id },
    )
    // One view per request, not per refetch.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [request?.id, canUpload])

  let content
  if (loading && !request) {
    content = <LinearProgress color="primary" aria-label="Loading" />
  } else if (error && !request) {
    content = <RequestLoadError error={error} onRetry={() => refetch()} />
  } else if (!request) {
    content = <RequestNotFound />
  } else if (!canUpload) {
    // Already uploaded (or answered): send the golfer to where the request stands.
    return <Redirect to={getRequestPath(requestId)} />
  } else {
    content = (
      <>
        <Typography className={classes.muted} style={{ marginBottom: 24 }}>
          {request.lessonType?.title}
          {request.orderNumber ? ` · Order #${request.orderNumber}` : ''}
        </Typography>
        <UploadForm request={request} />
      </>
    )
  }

  return (
    <Box className={classes.memberLayout}>
      <PageHeader title="Upload your swing videos" crumbs={CRUMBS} />
      <Box className={clsx(classes.clubPage, classes.memberPage)}>
        {content}
      </Box>
    </Box>
  )
}

export default UploadPage
